import React from 'react';
import { withPrefix, Link } from 'gatsby';


export default class Consent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          isSet: true,
          locale: this.props.locale
        };
        this.hasCookie = this.hasCookie.bind(this);
        this.setCookie = this.setCookie.bind(this);
    }

    componentDidMount() {
        this.setState(
            { isSet: this.hasCookie("consent") }
        )
    }

    
    hasCookie(){
        return decodeURIComponent(document.cookie).indexOf("consent=ok") > -1
    }

    setCookie(){
        let d = new Date();
        d.setTime(d.getTime() + (365*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = "consent=ok;" + expires + ";path=/";

        this.setState(
            {isSet: true}
        )

    }

    render() {
        
        const locale = this.state.locale
        return (
            <div className="consent" style={{display: this.state.isSet ? 'none' : 'flex' }}>
                <p>
                { locale === 'en' ? 'This site uses cookies from Google to provide services and analyze traffic.' : 'Diese Seite verwendet Cookies von Google, um Dienste bereitzustellen und Traffic zu analysieren.' }
                     </p>

                <div className="buttons">
                    <a className="consent-button" href="/datenschutz" target="_bank" > { locale === 'en' ? 'Privacy policy' : 'Datenschutzerklärung' }</a>
                    <button  className="consent-button" onClick={this.setCookie}> { locale === 'en' ? 'Got it!' : 'Alles Klar!'} </button> 
                </div>
            </div>
        );
    }
}